module.exports = __webpack_public_path__ + "static/media/paulo-andrade.36e40d61.png";